const $ = jQuery.noConflict();

'use strict';

const ResetPassword = {
	$submitBtn: $('#forgot-password-btn'),
	isFetching: false,

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		this.$submitBtn.on('click', this.submitEmail);
	},

	showMessage: function(message, type = 'error') {
		const $messageContainer = $('.js-profile-auth-messages');
		const messageClass = type === 'success' ? 'profile-auth__success' : 'profile-auth__error';

		$messageContainer.html(`<div class="${messageClass}">${message}</div>`);
	},

	clearMessages: function() {
		$('.js-profile-auth-messages').html('');
	},

	submitEmail: async function(event) {
		event.preventDefault();

		if (ResetPassword.isFetching) {
			return;
		}

		const email = $('#forgot-email').val().trim();

		ResetPassword.clearMessages();

		if (!email) {
			ResetPassword.showMessage('Unesite email adresu.');
			return;
		}

		ResetPassword.isFetching = true;

		try {
			const response = await fetch('/wp-json/office-pulse-api/v1/auth/reset-password', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({email}),
			});

			const result = await response.json();

			if (response.ok && result.success) {
				ResetPassword.showMessage('Email za resetovanje lozinke je poslat.', 'success');
			} else {
				ResetPassword.showMessage(result.error || 'Došlo je do greške.');
			}
		} catch (error) {
			ResetPassword.showMessage('Došlo je do greške. Pokušajte ponovo kasnije.');
		} finally {
			ResetPassword.isFetching = false;
		}
	},
};

export default ResetPassword;
